import FormJaivana from 'dashboard_jaivana_v1';



class CustomUbicacionesCantidades extends FormJaivana.form {
    constructor(props) {
        super(props);

        this.initForm = this.initForm.bind(this);
        this.gridOptionsUbicaciones    =   Object.assign({},this.gridOptions);
        this.cargarUbicaciones  =   this.cargarUbicaciones.bind(this);
        this.successUbicaciones =   this.successUbicaciones.bind(this);
        this.setButtonTrasladar =   this.setButtonTrasladar.bind(this);
        this.openModalUbicaciones   =   this.openModalUbicaciones.bind(this);
        this.cargarWmsZonas         =   this.cargarWmsZonas.bind(this);
        this.successWmsZonas        =   this.successWmsZonas.bind(this);
        this.cargarWmsRacks         =   this.cargarWmsRacks.bind(this);
        this.successWmsRacks        =   this.successWmsRacks.bind(this);
        this.cargarColumnas         =   this.cargarColumnas.bind(this);
        this.successColumnas        =   this.successColumnas.bind(this);
        this.cargarNiveles          =   this.cargarNiveles.bind(this);
        this.cargarTipoUbicacion    =   this.cargarTipoUbicacion.bind(this);
        this.clearCamposFormulario  =   this.clearCamposFormulario.bind(this);
        this.clearCamposFormularioProducto  =   this.clearCamposFormularioProducto.bind(this);
        this.trasladarCantidad      =   this.trasladarCantidad.bind(this);
        this.successTrasladar       =   this.successTrasladar.bind(this);
        this.clearValidCampos       =   this.clearValidCampos.bind(this);
        this.validNiveles           =   this.validNiveles.bind(this);
    }

    initForm() {
        this.getField('boton_cargar').setClick(this.cargarUbicaciones);
        this.getField('sucursal_id').setOnChange(this.cargarWmsZonas);
        this.getField('wms_zona_id').setOnChange(this.cargarWmsRacks);  
        this.getField('wms_nuevo_rack_id').setOnChange(this.cargarColumnas); 
        this.getField('numero_nivel').setOnChange(this.cargarNiveles);
        this.getField('nivel_numero').setOnChange(this.cargarTipoUbicacion);
        this.getField('boton_trasladar').setClick(this.trasladarCantidad);  
        //this.getField('wms_nuevo_racks_columnas').setOnChange(this.clearValidCampos);  
        this.getField('codigo_bodega').setOnChange(this.clearValidCampos);
        this.getField('producto').setOnChange(this.clearValidCampos);
        this.getField('codigo_bodega').setOnChange(this.clearCamposFormulario);

        this.getField('cantidad').setKeyUp(() => {
            if(this.getField('cantidad').getValue() === 0){
                this.getField('cantidad').setError(true,"Esta cantidad debe ser mayor a 0.");
            }else if(parseFloat(this.getField('cantidad').getValue()) > 9999999999999.99){
                this.getField('cantidad').setError(true,"Esta cantidad debe ser menor a 9999999999999.");
            }else{
                this.getField('cantidad').setError(false,"");
            }
        });

        this.getField('nombre').setOnChange(() => {
            if(this.getField('nombre').getValue() !== ""){
                this.getField('nombre').setError(false,"");
            }
            this.clearCamposFormularioProducto();
        });

        this.getField('nombre_producto').setOnChange(() => {
            if(this.getField('nombre_producto').getValue() !== ""){
                this.getField('nombre_producto').setError(false,"");
            }
            this.clearCamposFormularioProducto();
        });

        this.getField('wms_nuevo_rack_id').setDisabled(true);
        this.getField('wms_nuevo_racks_columnas').setDisabled(true);
        this.getField('nivel_numero').setDisabled(true);
    }
    cargarUbicaciones(){
        if(this.getField('codigo_bodega').valid() && this.getField('producto').valid() && this.getField('nombre').valid() && this.getField('nombre_producto').valid()){
            this.getField('codigo_bodega').setError(false,"* Este campo es requerido.");
            this.getField('producto').setError(false,"* Este campo es requerido.");

            let seguir = false;
            let seguir2 = false;

            if(this.getField('nombre').getValue() === ""){
                this.getField('nombre').setError(true,"* Este campo es requerido.");
            }else{
                this.getField('nombre').setError(false,"");
                seguir = true;
            }

            if(this.getField('nombre_producto').getValue() === ""){
                this.getField('nombre_producto').setError(true,"* Este campo es requerido.");
            }else{
                this.getField('nombre_producto').setError(false,"");
                seguir2 = true;
            }

            if(seguir && seguir2){

                let datos={ datos: {
                    codigo:this.getField('producto').getValue(),
                    codigo_bodega:this.getField('codigo_bodega').getValue(),
                } };
    
                this.generalFormatPmv = { tipo_servicio: 'inve-trasladarubicaciones', operacion: '1', operacion_tipo: 'consulta' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successUbicaciones,
                    error: this.error_,
                    general: this.generalFormatPmv
                });

            }
             /*this.generalFormat.nombre_accion = '368-ubicaciones_cantidades_codigo_producto_codigo_bodega';
             this.service.send(
                 {
                     endpoint:this.constant.formConfiguration(),
                     method:'GET',
                     body:body,
                     success: this.successUbicaciones, 
                     error:this.error_,
                     general: this.generalFormat,
                 });*/
         }else if (this.getField('codigo_bodega').getValue() === ''){
                   this.getField('codigo_bodega').setError(true,"* Este campo es requerido.");
         }else if (this.getField('producto').getValue() === ''){
                   this.getField('producto').setError(true,"* Este campo es requerido.");
         }       
    }
    successUbicaciones(data){
        if(data.data && data.data.length>0){
            this.gridOptionsUbicaciones['rowData']  =   data.data;
            let configCell = new Map();
            configCell.set(8,{cellRenderer:this.setButtonTrasladar ,field: 'Trasladar',width:110});
            this.getField('tabla_ubicaciones').initData(this.gridOptionsUbicaciones,configCell);
        }else{//de lo contrario no se muestra tabla
            this.getField('tabla_ubicaciones').toggle(false); 
        }
    }
    setButtonTrasladar(props){
        let button = document.createElement("input"); 
        button.onclick = ()=>this.openModalUbicaciones(props.data.id);//toma el id del regirtro seleccionado en la tabla
        button.setAttribute("id",'button_aprove_');
        button.setAttribute("class","buttonStyle");//,"width:100%; height: 100%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
        button.setAttribute("type","button");
        button.setAttribute("value","Trasladar");
        return this.createElementJaivana(button);
    }
    openModalUbicaciones(id){
        //this.cargarUbicaciones();
        this.getField('modal_trasladar').handleClickOpen();
    }
    cargarWmsZonas(){
        if(this.getField('sucursal_id').getValue() !== ''){

            let datos={ datos: {
                value: this.getField('sucursal_id').getValue()+"",
            } };
            
            this.generalFormatPmv = { tipo_servicio: 'inve-trasladarubicaciones', operacion: '1_4', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successWmsZonas,
                error: this.error_,
                general: this.generalFormatPmv
            });

            /*let body = {
                value:this.getField('sucursal_id').getValue(),
            }
             this.generalFormat.nombre_accion = '368-Busca_los_wms_zonas_que_contenga_la_sucursal_id';
             this.service.send(
                 {
                     endpoint:this.constant.formConfiguration(),
                     method:'GET',
                     body:body,
                     success: this.successWmsZonas, 
                     error:this.error_,
                     general: this.generalFormat,
                 });*/
        }
    }
    successWmsZonas(data){
        if(data.data && data.data.length>0){
            let opciones = [{'text':'Ninguno','value':' ','campos_cambian':{}}];
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.codigo +"-"+ item.descripcion;
                dataOp['campos_cambian'] = {};
                opciones.push(dataOp);
             })
            this.getField('wms_zona_id').setOptions(opciones);
        }       
    }
    cargarWmsRacks(){
        this.getField('wms_nuevo_racks_columnas').setValue(" ");
        this.getField('nivel_numero').setValue(" ");
        this.getField('wms_nuevo_rack_id').setValue(" ");

        this.getField('wms_nuevo_racks_columnas').setDisabled(true);
        this.getField('nivel_numero').setDisabled(true);
        this.getField('wms_nuevo_rack_id').setDisabled(true);

        if(this.getField('wms_zona_id').getValue() !== '' && this.getField('wms_zona_id').getValue() !== ' '){
            let opciones = [{'text':'Ninguno','value':' ','campos_cambian':{}}];
            this.getField('wms_nuevo_racks_columnas').setOptions(opciones);
            this.getField('nivel_numero').setOptions(opciones);
            this.clearValidCampos();

            let datos={ datos: {
                value:this.getField('wms_zona_id').getValue()+"",
            } };

            this.generalFormatPmv = { tipo_servicio: 'inve-trasladarubicaciones', operacion: '1_5', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successWmsRacks,
                error: this.error_,
                general: this.generalFormatPmv
            });

            /*
            let body = {
                value:this.getField('wms_zona_id').getValue(),
            }
             this.generalFormat.nombre_accion = '368-Busca_los_wms_nuevo_racks_que_contengan_wms_zona_id';
             this.service.send(
                 {
                     endpoint:this.constant.formConfiguration(),
                     method:'GET',
                     body:body,
                     success: this.successWmsRacks, 
                     error:this.error_,
                     general: this.generalFormat,
                 });*/
        }
    }
    successWmsRacks(data){
        let opcionesRacks = [];
        if(data.data && data.data.length>0){
            opcionesRacks = [{'text':'Ninguno','value':' ','campos_cambian':{}}];
                   data.data.forEach(item => {
                       let dataOp = {}
                       dataOp['value'] = item.id;
                       dataOp['text'] = item.numero;
                       dataOp['campos_cambian'] = {};
                       opcionesRacks.push(dataOp);
                    })
                   this.getField('wms_nuevo_rack_id').setOptions(opcionesRacks);
                   this.getField('tipo_ubicacion').setValue('');
                   
        }else if(data.data && data.data.length === 0) {
            opcionesRacks = [{'text':'Ninguno','value':' ','campos_cambian':{}}];
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = 0;
                dataOp['text'] = 0;
                dataOp['campos_cambian'] = {};
                opcionesRacks.push(dataOp);
             })
            this.getField('wms_nuevo_rack_id').setOptions(opcionesRacks);
            this.getField('wms_nuevo_racks_columnas').setOptions(opcionesRacks);
            this.getField('nivel_numero').setOptions(opcionesRacks);
            this.getField('tipo_ubicacion').setValue('');
            
        } 
        this.getField('wms_nuevo_rack_id').setDisabled(false);
    }
    cargarColumnas(){
        this.getField('wms_nuevo_racks_columnas').setValue(" ");
        this.getField('nivel_numero').setValue(" ");
        this.getField('wms_nuevo_racks_columnas').setDisabled(true);
        this.getField('nivel_numero').setDisabled(true);

        if(this.getField('wms_nuevo_rack_id').getValue() !== '' && this.getField('wms_nuevo_rack_id').getValue() !== ' '){
            this.clearValidCampos();
            let opciones = [{'text':'Ninguno','value':' ','campos_cambian':{}}];
            this.getField('nivel_numero').setOptions(opciones);
            
            let datos={ datos: {
                value:this.getField('wms_nuevo_rack_id').getValue()+"",
            } };

            this.generalFormatPmv = { tipo_servicio: 'inve-trasladarubicaciones', operacion: '1_6', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successColumnas,
                error: this.error_,
                general: this.generalFormatPmv
            });
            
            /*let body = {
                value:this.getField('wms_nuevo_rack_id').getValue(),
            }
             this.generalFormat.nombre_accion = '368-Busca_un_wms_nuevo_racks_columnas_por_wms_nuevo_rack_id';
             this.service.send(
                 {
                     endpoint:this.constant.formConfiguration(),
                     method:'GET',
                     body:body,
                     success: this.successColumnas, 
                     error:this.error_,
                     general: this.generalFormat,
                 });*/
        }
    }
    successColumnas(data){
        
        if(data.data && data.data.length>0){
            let opciones = [{'text':'Ninguno','value':' ','campos_cambian':{}}];             
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.columna_numero;
                dataOp['nivel'] = item.niveles;
                dataOp['tipo_ubicacion'] = item.tipo_ubicacion;
                dataOp['campos_cambian'] = {
                    columna_numero: item.columna_numero,
                    numero_nivel: item.niveles,
                    wms_tipos_ubicacion_id: item.wms_tipos_ubicacion_id,
                    tipo_ubicacion: item.tipo_ubicacion,
                    wms_nuevo_racks_columnas_id: item.id
                };
                opciones.push(dataOp);
                
                //this.getField('wms_nuevo_racks_columnas_id').setValue(item.id);
                //this.getField('tipo_ubicacion').setValue(item.tipo_ubicacion);
             })
            this.getField('wms_nuevo_racks_columnas').setOptions(opciones);
            this.getField('wms_nuevo_racks_columnas').setDisabled(false);
        }
    }
    cargarNiveles(){
        if(this.getField('numero_nivel').getValue() !== '' && this.getField('numero_nivel').getValue() !== 0){            
            let options = [{
                'text':'Ninguno',
                'value':'',
                'campos_cambian':{}
            }];
            for(let item = 1; item <= parseInt(this.getField('numero_nivel').getValue()); item++){
                let dataOp = {}
                dataOp['value'] = item+"";
                dataOp['text'] =  item+"";
                dataOp['campos_cambian'] = {};
                options.push(dataOp);
            }
            this.getField('nivel_numero').setDisabled(false);
            this.getField('nivel_numero').setOptions(options);
        }
    }
    getter(campo){
        return this.getField(campo).getValue();
    }
    cargarTipoUbicacion(){
        this.validNiveles();
    }
    trasladarCantidad(){
        if(this.getField('wms_zona_id').valid() &&
           this.getField('wms_nuevo_rack_id').valid()  &&
           this.getField('wms_nuevo_racks_columnas_id').valid() &&
           this.getField('nivel_numero').valid() &&
           this.getField('cantidad').getValue() !== ''&&
           parseFloat(this.getField('cantidad').getValue()) > 0 &&
           parseFloat(this.getField('cantidad').getValue()) < 9999999999999.99 &&
           this.getField('cantidad').valid() &&
           this.getField('tipo_ubicacion').getValue() !== '' &&
           this.getField('id_ubicacion').getValue() !== '' &&
           this.getField('producto').getValue() !== '' &&
           this.getField('codigo_bodega').getValue() !== ''){
               //El campo sucursal_id es requerido, El campo columna_numero es requerido, Tipo de dato incompatible para wms_nuevo_racks_columnas_id, El campo nivel_numero es requerido 502:Error en la petición
            this.getField('boton_trasladar').setDisabled(true);
            let datos={ datos: {
                sucursal_id:11111,
                columna_numero:1111,
                nivel_numero:1111,
                wms_nuevo_racks_columnas:1111,
                id:this.getField('id_ubicacion').getValue(),
                codigo:this.getField('producto').getValue(),
                codigo_bodega:this.getField('codigo_bodega').getValue(),
                wms_nuevo_racks_columnas_id:parseInt(this.getField('wms_nuevo_racks_columnas_id').getValue()),
                nivel:parseInt(this.getField('nivel_numero').getValue()),
                cantidad:this.getField('cantidad').getValue(),
            } };

            this.generalFormatPmv = { tipo_servicio: 'inve-trasladarubicaciones', operacion: 'trasladar', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successTrasladar,
                error: this.error_,
                general: this.generalFormatPmv
            });
           /*let body = {
                sucursal_id:11111,
                columna_numero:1111,
                nivel_numero:1111,
                wms_nuevo_racks_columnas:1111,
                id:this.getField('id_ubicacion').getValue(),
                codigo:this.getField('producto').getValue(),
                codigo_bodega:this.getField('codigo_bodega').getValue(),
                wms_nuevo_racks_columnas_id:this.getField('wms_nuevo_racks_columnas_id').getValue(),
                nivel:this.getField('nivel_numero').getValue(),
                cantidad:this.getField('cantidad').getValue(),
            }
             this.generalFormat.nombre_accion = '368-Permite_hacer_traslado_cantidad_productos_ubicacion';
             this.service.send(
                 {
                     endpoint:this.constant.formConfiguration(),
                     method:'PUT',
                     body:body,
                     success: this.successTrasladar, 
                     error:this.error_,
                     general: this.generalFormat,
                 });*/
        }else if(this.getField('ubicacion_codigo').getValue() === ''){
            this.getField('ubicacion_codigo').setError(true,"* Este campo es requerido.");
        }
    }
    successTrasladar(data){
        if(data.estado_p === 200){
            this.cargarUbicaciones();
            this.getField('modal_trasladar').handleClose();
        }
        this.getField('boton_trasladar').setDisabled(false);
    }
    clearValidCampos(){
        let opciones = [{'text':'Ninguno','value':' ','campos_cambian':{}}];
        this.getField('nivel_numero').setOptions(opciones);
        this.getField('wms_zona_id').setError(false,"* Este campo es requerido.");
        this.getField('wms_nuevo_rack_id').setError(false,"* Este campo es requerido.");
        this.getField('wms_nuevo_racks_columnas').setError(false,"* Este campo es requerido.");
        this.getField('nivel_numero').setError(false,"* Este campo es requerido.");
        this.getField('tipo_ubicacion').setError(false,"* Este campo es requerido.");
        this.getField('cantidad').setError(false,"* Este campo es requerido.");
        this.getField('codigo_bodega').setError(false,"* Este campo es requerido.");
        this.getField('producto').setError(false,"* Este campo es requerido.");
    }
    validNiveles(){
        this.getField('nivel_numero').setError(false,"* Este campo es requerido.");
    }
    clearCamposFormulario(){         
            this.getField('producto').setValue("");
            this.getField('nombre_producto').setValue("");
            this.getField('tabla_ubicaciones').toggle(false);    
    }
    clearCamposFormularioProducto(){
        this.getField('tabla_ubicaciones').toggle(false); 
    }
}

FormJaivana.addController('inve-trasladarubicaciones',CustomUbicacionesCantidades);
export default CustomUbicacionesCantidades;